<template>
<div >






<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="mt-4" v-if="!loading" style="min-height:450px">

<FileUpload   accept=".xlsx, .xls, .csv" @select="onFilesAdded"     v-model="files" :multiple="false" :showUploadButton="false" :showCancelButton="false" chooseLabel="Dosya Seçin" :fileLimit="1"   :maxFileSize="1000000" class="">
   <template #empty>
      <p>Dosyayı sürükleyip bırakın</p>
  </template>
</FileUpload>

<SortableTable :data="items" :columns="columns" routename="City" deleteobjectname="city" @dataDeleted="getData"></SortableTable>
</div>

</div>
</template>

<script>
const columns_arr = ["A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","AA"];
import * as XLSX from 'xlsx/xlsx.mjs';
export default {

  name: 'CertificatetypeGeneral',

  data () {
    return {    	
      items:null,
      loading:true,
      files:null,
      current_row:1,
      current_column:"A",
      uploadlist:[],

      columns:[
      {
        type:"text",
        field:"city_name",
        header:"sehir",
        hide_on_mobile:false,
      },

      ]
    }
  },
  mounted()
  {    
    this.getData()
  },
  methods:{
   
  	async getData()
    {
      this.loading = await true
       let items = await this.generalApiGetWithoutLoader("cities/"+this.$route.params.id)  
       for(let item of items)     
       {
        item.city_name = item.name
       }
       this.items = await items
       this.loading = await false
    }, 
    onFilesAdded(event)
    {
     console.log(event);
     this.handleXml(event.files[0])      
    },
    uploadList()
    {
      console.log("uploadList")
      console.log(this.uploadlist)
      //return false
      let formdata = new FormData()
      formdata.append("list",JSON.stringify(this.uploadlist))
      this.generalSubmission(formdata,"cities/"+this.$route.params.id,this.getData)
    },
    handleXml(f)
    {     
      let reader = new FileReader()

      reader.onload = (e)=>{
      let data = new Uint8Array(e.target.result)
      let workbook = XLSX.read(data, {type: 'array'});
      let current_sheet = workbook.SheetNames[0]; 
      this.worksheet = workbook.Sheets[current_sheet];  
      let current_cell_value =this.getCurrentCellValue()
      console.log("CURRENT CELL VALUE")
      console.log(current_cell_value)
      if(current_cell_value=="ISO" || current_cell_value=="REGION")
      {
        
        this.current_row ++
        this.current_column = "D"
        let final = this.readBusinessLineDetailed()
      }
      else
      {
         
        let final = this.readBusinessLine()
      }

      
      this.uploadList()      
      }
      reader.readAsArrayBuffer(f);
    },

    getCurrentCellValue()
    {
      let current_cell_address =this.current_column+this.current_row;       
      let current_cell = this.worksheet[current_cell_address];
      let current_cell_value = (current_cell ? current_cell.v : undefined);
      if(current_cell_value==undefined)
      {
        current_cell_value = false
      }
      return current_cell_value;
    },
    async readBusinessLine()
    {
      let data = this.getCurrentCellValue()
      if(!data)
      {
        return "done"
      }
      else
      {
        this.current_row ++
        this.uploadlist.push(data)
        this.readBusinessLine()
      }
    },
    async readBusinessLineDetailed()
    {
      let data = this.getCurrentCellValue()
      if(!data)
      {
        return "done"
      }
      else
      {
        let prev = this.uploadlist.findIndex((item)=>{return item == data})
        if(prev==-1)
        {          
          this.uploadlist.push(data)
        }
        this.current_row ++        
        this.readBusinessLineDetailed()        
      }
    },


  }
};
</script>

<style lang="css" scoped>
</style>